/**
 * Stop event handler for draggable node views.
 *
 * This handler allows drag events to propagate to ProseMirror for proper
 * drop cursor handling while stopping other events that could interfere
 * with the node view's behavior.
 *
 * Use this with `stopEvent` option in `ReactNodeViewRenderer` or `AngularNodeViewRenderer`
 * for draggable atom nodes that use custom node views.
 */
export function draggableNodeStopEvent({ event }: { event: Event }): boolean {
  const isDragEvent = /dragstart|dragover|dragend|drop/.test(event.type);
  if (isDragEvent) return false;

  return !/mousedown|drag|drop/.test(event.type);
}
